/* global Vue, VueI18n, VeeValidate, LOYALTY_API */

import { Notifications, setSuccessAndStopLoading, setErrorAndStopLoading, startLoading } from '../apps/components/Notifications'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import '../validation-rules'

const i18n = CreateI18n(messagesSpecific)

const ActivationLinkApp = Vue.createApp({
  name: 'ActivationLinkApp',
  components: { Notifications },
  template: '#activation-link-app-template',
  setup () {
    const form = Vue.reactive({})
    const formErrors = Vue.reactive({})
    const showForm = Vue.ref(true)
    const formElement = Vue.ref(null)
    const validationSchema = {
      email: 'required|email',
    }
    const { t } = VueI18n.useI18n()
    const { handleSubmit, errors, isSubmitting } = VeeValidate.useForm({ validationSchema })

    const fieldRefs = Vue.reactive({})
    Object.keys(validationSchema).forEach((field) => {
      const fieldObj = VeeValidate.useField(field, undefined, {
        validateOnValueUpdate: false,
      })
      form[field] = fieldObj.value
      formErrors[field] = fieldObj.errorMessage
      fieldRefs[field] = fieldObj
    })

    Vue.watch(isSubmitting, () => {
      if (Object.keys(errors).length > 0 && formElement.value) {
        const highlight = Array.from(formElement.value.querySelectorAll('.field-error')).filter(er => er.innerHTML)[0] || null
        if (highlight) { highlight.parentNode.scrollIntoView({ behavior: 'smooth' }) }
      }
    })

    const sendForm = handleSubmit(async () => {
      startLoading('handleSubmit')
      try {
        const response = await fetch(`${LOYALTY_API}/api/v1/PartialRegistrationContinue`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form),
        })
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        const status = await response.json()
        showForm.value = false
        setSuccessAndStopLoading({ details: t(`activation.success.${status.requestStatus}`) })
      } catch (err) {
        setErrorAndStopLoading(err)
      }
    })

    function validateField (field) {
      fieldRefs[field].validate()
    }

    return {
      form,
      formElement,
      formErrors,
      sendForm,
      showForm,
      validateField,
    }
  },
})

const appElement = document.getElementById('activation-link-app')

if (appElement) {
  ActivationLinkApp.use(i18n)
  ActivationLinkApp.mount(appElement)
}

export default ActivationLinkApp
